import { Link } from "@remix-run/react";
import { Github, MessageCircle, Twitter, Terminal, Code, Zap } from "lucide-react";

// 添加Discord图标组件
function DiscordIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M20.317 4.3698a19.7913 19.7913 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.037 19.7363 19.7363 0 00-4.8852 1.515.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 01.0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 01.0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 01-.0066.1276 12.2986 12.2986 0 01-1.873.8914.0766.0766 0 00-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 00.0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 00.0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 00-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419-.0190 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9460 2.4189-2.1568 2.4189Z"/>
    </svg>
  );
}

export function Footer() {
  return (
    <footer className="bg-slate-950 border-t border-slate-800">
      <div className="container py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Left: About */}
          <div className="space-y-6">
            <div className="border-l-4 border-blue-400 pl-4">
              <h4 className="text-lg font-bold text-slate-100">
                Stellar Blade Mods
              </h4>
            </div>
            
            <div className="bg-slate-900 rounded-lg p-6 border border-slate-700">
              <div className="space-y-4 text-slate-300">
                <div className="flex items-center gap-3">
                  <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
                  <span className="text-slate-400">Project:</span>
                  <span className="text-green-400">Stellar Blade Mod Hub</span>
                </div>
                
                <div className="flex items-center gap-3">
                  <div className="w-2 h-2 bg-blue-400 rounded-full animate-pulse"></div>
                  <span className="text-slate-400">Status:</span>
                  <span className="text-blue-400">Early Access</span>
                </div>
                
                <div className="flex items-center gap-3">
                  <div className="w-2 h-2 bg-purple-400 rounded-full animate-pulse"></div>
                  <span className="text-slate-400">Mission:</span>
                  <span className="text-slate-300">Curating premium mods for the community</span>
                </div>
              </div>
            </div>
          </div>

          {/* Right: Connect With Us */}
          <div className="space-y-6">
            <div className="border-l-4 border-purple-400 pl-4">
              <h4 className="text-lg font-bold text-slate-100">
                Connect With Us
              </h4>
            </div>
            
            <div className="bg-slate-900 rounded-lg p-6 border border-slate-700">
              <div className="space-y-4">
                <p className="text-slate-400 mb-4">Join our community and stay updated:</p>
                
                <div className="space-y-3">
                  <a 
                    href="https://discord.gg/daYR38qPB2"
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="flex items-center gap-3 text-slate-300 hover:text-indigo-400 transition-colors cursor-pointer"
                  >
                    <DiscordIcon className="h-4 w-4" />
                    <span>Join our Discord community</span>
                  </a>
                  
                  <div className="flex items-center gap-3 text-slate-300 hover:text-blue-400 transition-colors cursor-pointer">
                    <Twitter className="h-4 w-4" />
                    <span>Follow us on X (Coming Soon)</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Legal Links & Terminal Footer */}
        <div className="mt-12 pt-8 border-t border-slate-800">
          <div className="bg-slate-900 rounded-lg p-4 border border-slate-700">
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 text-sm">
              {/* Legal Links */}
              <div className="flex flex-wrap justify-center lg:justify-start gap-4">
                <Link 
                  to="/contact" 
                  className="text-slate-400 hover:text-blue-400 transition-colors text-sm"
                >
                  Contact
                </Link>
                <span className="text-slate-600">|</span>
                <Link 
                  to="/privacy-policy" 
                  className="text-slate-400 hover:text-blue-400 transition-colors text-sm"
                >
                  Privacy Policy
                </Link>
                <span className="text-slate-600">|</span>
                <Link 
                  to="/terms-of-use" 
                  className="text-slate-400 hover:text-blue-400 transition-colors text-sm"
                >
                  Terms of Use
                </Link>
                <span className="text-slate-600">|</span>
                <Link 
                  to="/disclaimer" 
                  className="text-slate-400 hover:text-blue-400 transition-colors text-sm"
                >
                  Disclaimer
                </Link>
              </div>

              {/* Copyright Footer */}
              <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                <div className="flex items-center gap-2 text-slate-400 justify-center sm:justify-start">
                  <span>© {new Date().getFullYear()} Stellar Blade Mods</span>
                </div>
                
                <div className="flex items-center justify-center sm:justify-start gap-4 text-xs text-slate-500">
                  <div className="flex items-center gap-1">
                    <Code className="h-3 w-3" />
                    <span>Built with passion</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <Zap className="h-3 w-3" />
                    <span>Powered by community</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
} 